import { render, staticRenderFns } from "./mixesIndex.vue?vue&type=template&id=1cffba15&"
import script from "./mixesIndex.vue?vue&type=script&lang=js&"
export * from "./mixesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports